import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PointList from "./PointList";
import tournamentActions from "../../../../redux/reducers/tournamentReducer/tournamentActions";
import * as tournamentThunks from "../../../../redux/thunks/tournamentThunks";

const PointFairPlayListContainer = ({
  organizerId,
  tournamentId,
  loading,
  tournament,
  setTournamentKeyValue,
  updateTournament,
  show,
}) => {
  const updateTournamentHandler = () =>
    updateTournament(organizerId, tournamentId);

  return (
    show && (
      <PointList
        tournament={tournament}
        loadingFetchTournament={loading.tournament.loadTournament}
        loadingSavePoints={loading.tournament.updateTournament}
        setTournamentKeyValue={setTournamentKeyValue}
        updateTournament={updateTournamentHandler}
        panelTitle="Tarjetas"
        rowsMap={[
          {
            id: "pointsYellowCard",
            name: "Amarilla",
          },
          {
            id: "pointsRedCard",
            name: "Roja",
          },
          {
            id: "pointsBlueCard",
            name: "Azul",
          },
        ]}
      />
    )
  );
};

const mapState = (state) => ({
  loading: state.loading,
  tournament: state.tournament.single,
  groups: state.group.all,
  group: state.group.single,
});

const mapDispatch = (dispatch) => ({
  setTournamentKeyValue: (key, value) =>
    dispatch(tournamentActions.setTournamentKeyValue(key, value)),
  updateTournament: (organizerId, tournamentId) =>
    dispatch(tournamentThunks.updateTournament(organizerId, tournamentId)),
});

export default withRouter(
  connect(mapState, mapDispatch)(PointFairPlayListContainer)
);
